import type { FC, ReactNode } from 'react'

import { Container } from '@/components/generals/container'
import { NewsletterForm } from '@/components/content/newsletter-form'

export const HomeNewsletter: FC = (): ReactNode => {
    return (
        <section id='subscribe' className='scroll-mt-20'>
            <Container className='pt-16 sm:pt-20'>
                <div className='rounded-3xl border border-border bg-card px-6 py-12 sm:px-12 sm:py-16'>
                    <div className='mx-auto flex max-w-2xl flex-col items-center gap-5 text-center'>
                        <span className='text-xs font-semibold uppercase tracking-[0.18em] text-primary'>
                            The weekly dispatch
                        </span>
                        <h2 className='font-heading text-3xl font-semibold tracking-tight text-foreground sm:text-4xl'>
                            One calm email a week. No noise.
                        </h2>
                        <p className='text-base leading-relaxed text-muted-foreground'>
                            A short, useful roundup of our best new writing on nutrition, sleep,
                            movement, and mind-body practice, distilled into something you can act
                            on.
                        </p>

                        <div className='mt-2 flex w-full justify-center'>
                            <NewsletterForm />
                        </div>

                        <p className='text-xs text-muted-foreground'>
                            Join a growing community of readers. Unsubscribe anytime.
                        </p>
                    </div>
                </div>
            </Container>
        </section>
    )
}
